module.exports = __webpack_public_path__ + "static/media/loginBg3.aa6cbbe4.png";